export default IconArrowRightFromArc => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-arrow-right-from-arc" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M15 12h-12" />
  <path d="M7 8l-4 4l4 4" />
  <path d="M12 21a9 9 0 0 0 0 -18" />
</svg>`;